<h2 mat-dialog-title><strong>Sesión Expirada</strong></h2>
Favor volver a iniciar sesión
<br><br>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" id="boton" (click)="onSubmit()">Aceptar</button>
</div>